import React from "react";
import Axios from "axios";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import SimpleDialogDemo from "../../../../Landing/LayoutContainers/SimpleDialog";

// El valor guardado de un campo tipo "photo" es la URL completa del
// archivo en Storage — en vez de mostrarla cruda en la celda de la tabla
// de ingresos, se abre el Dialog genérico que ya se usa en el panel con la
// foto, un botón de descarga real (vía blob, un <a download> normal no
// descarga archivos de otro origen como Firebase Storage) y la URL debajo.
export default function PhotoFieldValue({ url }) {
  function nombreArchivo() {
    try {
      const sinQuery = url.split("?")[0];
      const partes = decodeURIComponent(sinQuery).split("/");
      return partes[partes.length - 1] || "foto";
    } catch (e) {
      return "foto";
    }
  }

  function descargar() {
    Axios({ url, method: "GET", responseType: "blob" }).then((response) => {
      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", nombreArchivo());
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  }

  if (!url) return <>N/A</>;

  return (
    <SimpleDialogDemo buttonText={"Ver foto"}>
      <div style={{ padding: 20, textAlign: "center", maxWidth: 500 }}>
        <img
          src={url}
          alt="Foto del campo"
          style={{
            maxWidth: "100%",
            maxHeight: "60vh",
            display: "block",
            margin: "0 auto 20px",
          }}
        />
        <Button variant="contained" color="primary" onClick={descargar}>
          Descargar
        </Button>
        <Typography variant="body2" style={{ marginTop: 20, wordBreak: "break-all" }}>
          {url}
        </Typography>
      </div>
    </SimpleDialogDemo>
  );
}
